import React from 'react';
import classes from './BasicDropdownOption.module.scss';

export default function BasicDropdownOption({ text, selected = false, isLeft = true, clickHandler, icon = false }) {
  return (
    <div role="presentation" className={`${classes.container} ${isLeft ? '' : classes.right}`} onClick={clickHandler}>
      <div className={`${classes.marker} ${selected ? classes.selected : ''}`} />
      <p className={classes.text}>{text}</p>
      <div style={{ width: '16px', height: '16px' }}>{icon}</div>
    </div>
  );
}
